ALLOWED_CONTROLLER = 'trouble_tickets'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  today = new Date
  full_date = today.getMonth() + 1 + '_' + today.getDate() + '_' + today.getFullYear()

  troubleTicketsTable = $('#trouble_tickets').dataTable
    dom: '<"fg-toolbar ui-toolbar ui-widget-header ui-helper-clearfix ui-corner-tl ui-corner-tr"lBfr>'+
      't'+
      '<"fg-toolbar ui-toolbar ui-widget-header ui-helper-clearfix ui-corner-bl ui-corner-br"ip>'
    sPaginationType: "full_numbers"
    bJQueryUI: true
    bProcessing: true
    bServerSide: true
    iDisplayLength: 50
    buttons: [
      { extend: 'csvHtml5', text: 'Download', title: 'problem_reports_' + full_date }
    ]
    sAjaxSource: $('#trouble_tickets').data('source')
    order: [ [ 0, "desc" ] ]
    lengthMenu: [ 10, 25, 50, 75, 100, 500 ]
    aoColumnDefs:
      [ { 'bSortable': false, 'aTargets': [ 4 ] } ]
    createdRow: (row, data, rowIndex) ->
      $.each $('td', row), (colIndex) ->
        if colIndex == 5 && isNetworked(data[colIndex]) # location
          $(this).attr('title', "networked location")
        else if colIndex == 6 && isNetworked(data[colIndex]) # locker
          $(this).attr('title', "networked locker")
    fnServerData: _.debounce((sSource, aoData, fnCallback, oSettings) ->
      $.ajax
        dataType: 'json'
        type: 'GET'
        url: sSource
        data: aoData
        success: fnCallback
    , 1200)

  $('div[data-selector="dialog_form"] form').bind 'ajax:complete', ->
    $('*[data-selector="dialog_form"]').dialog("close")
    troubleTicketsTable.fnDraw()
  $('div[data-selector="dialog_priority"] form').bind 'ajax:complete', ->
    $('*[data-selector="dialog_priority"]').dialog("close")
    troubleTicketsTable.fnDraw()

  troubleTicketsTable.on "draw.dt", (e) ->
    $('a[data-selector="toggle-category"]').unbind('click')
    $('a[data-selector="add-category"]').on "click", (e) ->
      e.preventDefault()
      categoriesDiv = $("div[data-selector='categories']")
      parent = $(e.target).parent()
      topPosition = $("div#trouble_tickets_wrapper").position().top + parent.position().top + parent.outerHeight()
      categoriesDiv.css("top", topPosition + "px")
      $('a[data-selector="toggle-category"]').attr("data-url", $(e.target).attr("data-url"))
      categoriesDiv.show()

      $('a[data-selector="toggle-category"]').on "click", (e) ->
        e.preventDefault()
        $.ajax
          type: 'GET',
          url: $(e.target).attr("data-url") + '?category_id=' + $(e.target).attr("data-id")
          complete: ->
            troubleTicketsTable.fnDraw()
            $("div[data-selector='categories']").hide()

  isNetworked = (dataElement) ->
    dataElement.includes "networked-item" if dataElement # networked location/locker contains this identification

  $('#select_by_priority').ddslick({
    width: 120,
    onSelected: (selectedData) ->
      $('#filter_by_priority').val(selectedData.selectedData.value)
  })

$(document).ready(ready)
